import { render } from "./PaginationShop.vue?vue&type=template&id=02f90231&scoped=true&ts=true"
import script from "./PaginationShop.vue?vue&type=script&lang=ts"
export * from "./PaginationShop.vue?vue&type=script&lang=ts"

import "./PaginationShop.vue?vue&type=style&index=0&id=02f90231&lang=scss&scoped=true"

import exportComponent from "/var/my_garage_api_front/PROD/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02f90231"]])

export default __exports__
import QPagination from 'quasar/src/components/pagination/QPagination.js';
import QSelect from 'quasar/src/components/select/QSelect.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import QItemLabel from 'quasar/src/components/item/QItemLabel.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QPagination,QSelect,QItem,QItemSection,QItemLabel});
